<template>
    <div class="row">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-else class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">
                            Create Event
                        </div>
                    </div>
                    <div class="center-separated-block center-separated-block-cal mt-3">
                        <div class="left-block">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Title of event</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="event.title"
                                        >
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="center-separated-block  center-separated-block-half">

                                        <EventDatePicker
                                            :title="'Start Date and Time'"
                                            :part="'start'"
                                            :date-string.sync="event.start_date"
                                            @data-changed="updateDate"
                                        />
                                        <div class="sep-line"></div>

                                        <EventDatePicker
                                            :title="'End Date and Time'"
                                            :part="'end'"
                                            :date-string="event.end_date"
                                            @data-changed="updateDate"
                                        />

                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="d-flex align-items-center">
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input
                                                    class="form-check-input-checkbox"
                                                    type="checkbox"
                                                    id="home-office"
                                                    v-model="event.all_day"
                                                    @change="checkEndDateAndTime"
                                                >
                                                <label class="form-check-label" for="home-office">
                                                    All Day
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-1">
                                    <img src="/img/svg/icons-calendar.svg" alt="" class="img-btn mt-3">
                                </div>
                                <div class="col-9 col-sm-5 col-lg-3 pl-0">
                                    <div class="form-group form-group-1">
                                        <select
                                            class="custom-select "
                                            v-model="event.calendar_id"
                                            @change="setColorOfEvent(event.calendar_id)"
                                        >
                                            <option
                                                v-for="calendar in listOfCalendars"
                                                :selected="calendar.id"
                                                :value="calendar.id"

                                            >{{ calendar.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-2 pl-0">
                                    <a href="javascript:void(0)"
                                       class="color--btn"
                                       @click="showCustomModal('color', 1)"
                                    >
                                        <div
                                            class="color"
                                            :class="'background-color--c' + (selectedColor)"></div>
                                        <i class="fa fa-chevron-down ml-2"></i>
                                    </a>

                                    <EventColorModal
                                        :modal-id="getCustomModalId('color', 1)"
                                        :confirm-text="`Save`"
                                        :reject-text="`Cancel`"
                                        @update-color="updateEventColor"
                                    >
                                    </EventColorModal>
                                </div>

                                <div class="col-12">
                                    <div class="tab-content" id="myTabContent">
                                        <div class="tab-pane fade show active" id="user-note" role="tabpanel"
                                             aria-labelledby="tab-12">
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="form-group form-group-1">
                                                        <label for="" class="form-label">Location</label>
                                                        <select class="custom-select " v-model="event.client_id">
                                                            <option
                                                                v-for="location in listOfClients"
                                                                :value="location.id">{{ location.name }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div
                                                    class="col-12"
                                                    v-for="(notification, index) in event.notifications"
                                                    :key="index"
                                                >
                                                    <NotificationItem
                                                        :is-deletable="event.notifications.length > 1"
                                                        :notification-info="notification"
                                                        :index="index"
                                                        @data-changed="updateNotification"
                                                        @delete="deleteNotification"
                                                    >
                                                    </NotificationItem>

                                                </div>
                                                <div class="mb-4 col-12">
                                                    <a
                                                        href="javascript:void(0)"
                                                        class="link"
                                                        @click="addNotification"
                                                    >
                                                        + Add Notification</a>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group form-group-1">
                                                        <label for="" class="form-label">Notes</label>
                                                        <textarea
                                                            type="text"
                                                            class="form-control"
                                                            v-model="htmlNotes"
                                                        ></textarea>
                                                    </div>
                                                </div>
                                                <div class="col-md-12" v-if="event.calendar_id === 4">
                                                    <div class="form-group form-group-1">
                                                        <label for="" class="form-label">Status:</label>
                                                        <div class="buttons-type-multiselect two-btns ">
                                                            <div class="item inactive">
                                                                <input
                                                                    type="radio"
                                                                    class="rad"
                                                                    id="id-1132"
                                                                    value="done"
                                                                    v-model="event.status"
                                                                    @click="toggleStatus('done')"
                                                                >
                                                                <label for="id-1132">
                                                                    <div class="ttl">Done</div>
                                                                </label>
                                                            </div>
                                                            <div class="item active">
                                                                <input
                                                                    type="radio"
                                                                    class="rad"
                                                                    id="id-1212"
                                                                    value="missed"
                                                                    v-model="event.status"
                                                                    @click="toggleStatus('missed')"
                                                                >
                                                                <label for="id-1212">
                                                                    <span class="ttl">Missed</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="admin-note" role="tabpanel"
                                             aria-labelledby="tab-22">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sep-line sep-line-1"></div>

                        <ListOfGuests
                            :invited-guests="event.guests"
                            @data-changed="setListOfGuests"
                            @delete-users="deleteGuestFromList"
                        ></ListOfGuests>

                    </div>
                    <div class="btns-wrap">
                        <a href="/master-admin/calendar" class="btn btn--outline-primary w-100 w-sm-auto">Cancel</a>
                        <button
                            class="btn btn--secondary w-100 w-sm-auto"
                            @click="validateFields"
                        >Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import ListOfGuests from "./ListOfGuests.vue";
import CalendarService from "./services/CalendarService";
import CommonService from "../../../AppUser/resources/js/services/CommonService";
import NotificationItem from "./NotificationItem.vue";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import EventColorModal from "./EventColorModal.vue";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import EventDatePicker from "./EventDatePicker.vue";
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";

export default {
    name: 'EventDetails',
    props: {
        eventInfo: {
            type: Object,
            required: false,
        }
    },
    components: {
        EventDatePicker,
        EventColorModal,
        NotificationItem,
        ListOfGuests
    },
    mixins: [ModalHandler, DateConverter, StyleHandler],
    data() {
        return {
            loading: true,
            isUpdate: false,
            showTimePanel: false,
            listOfCalendars: [],
            listOfClients: [],
            selectedColor: null,
            event: {
                id: null,
                title: null,
                start_date: '',
                end_date: '',
                all_day: false,
                calendar_id: 1,
                client_id: null,
                notifications: [],
                status: null,
                notes: null,
                color: null,
                guests: [],
                deletedNotifications: [],
                deletedGuests: [],
            }
        }
    },
    computed: {
        htmlNotes: {
            get() {
                return this.event.notes ? this.event.notes.replace(/<\/?[^>]+(>|$)/g, "") : "";
            },
            set(value) {
                this.event.notes = value || "";
            }
        }
    },


    methods: {
        checkEndDateAndTime() {
            if (this.event.all_day) {
                this.event.end_date = this.setAllDayEndDate(this.event.start_date)
            }
        },
        toggleStatus(newStatus) {
            this.event.status = this.event.status === newStatus ? null : newStatus;
        },
        deleteGuestFromList(result) {
            this.event.deletedGuests = result
        },
        toggleTimePanel() {
            this.showTimePanel = !this.showTimePanel;
        },
        handleOpenChange() {
            this.showTimePanel = false;
        },
        addNotification() {
            this.event.notifications.push({
                id: null,
                reminder_time: 1,
                reminder_unit: 'hours'
            })
        },
        deleteNotification(notification) {
            if (notification.id) {
                this.event.deletedNotifications.push(notification.id);
            }
            this.event.notifications.splice(notification.index, 1);
        },
        async getListOfCalendars() {
            try {
                const {data: response} = await CalendarService.getCalendarList()
                this.listOfCalendars = response
                if (this.eventInfo?.color) {
                    this.selectedColor = this.eventInfo.color
                } else if (this.eventInfo) {
                    this.setColorOfEvent(this.eventInfo.calendar_id)
                } else {
                    this.setColorOfEvent(1)
                }
            } catch (e) {
                console.error(e)
            }
        },
        async getListOfClients() {
            try {
                const {data: response} = await CommonService.getClientsList()
                this.listOfClients = response
            } catch (e) {
                console.error(e)
            }
        },
        validateFields() {
            if (!this.event.title ||  this.event.title.trim() === ""){
                this.$showErrorMessage('Please provide an event name')
            } else if (!this.event.start_date || !this.event.end_date) {
                this.$showErrorMessage('Please provide an event time')
            } else {
                this.storeEvent()
            }
        },
        async storeEvent() {
            this.$showLoadingMessage()
            const payload = {
                ...this.event,
                start_date: this.parseTimeForEvent(this.event.start_date),
                end_date: this.parseTimeForEvent(this.event.end_date),
            }
            try {
                await CalendarService.saveEvent(payload)
                this.$showSuccessMessage('The event has been saved')
                console.log(payload)
                setTimeout(() => {
                    window.location.href = '/master-admin/calendar'
                }, 1000)
            } catch (e) {
                this.$showErrorMessage('The event was not saved. Please reload page and try again')
            }
        },
        setListOfGuests(result) {
            this.event.guests = result
        },
        setColorOfEvent(calendarId) {
            const foundCalendar = this.listOfCalendars.find(item => item.id === calendarId)
            if (foundCalendar) {
                this.selectedColor = foundCalendar.color
                this.event.color = foundCalendar.color
            }
        },
        updateEventColor(result) {
            this.selectedColor = result.id
            this.event.color = result.id
        },
        updateDate(result, part) {
            if (!result) {
                this.event.all_day = false
            }
            if (part === 'start') {
                this.event.start_date = result
            } else {
                this.event.end_date = result
            }
        },
        updateNotification(result) {
            this.event.notifications.splice(result.index, 1, result);
        },
        setData() {
            for (const key of Object.keys(this.eventInfo)) {
                if (this.event.hasOwnProperty(key)) {
                    this.event[key] = this.eventInfo[key];
                }
            }
            this.event.start_date = this.parseTimeForPicker(this.eventInfo.start_date)
            this.event.end_date = this.parseTimeForPicker(this.eventInfo.end_date)
            this.loading = false
        },
    },

    mounted() {
        this.getListOfClients();
        this.getListOfCalendars();

        if (this.eventInfo) {
            this.setData();
        } else {
            this.loading = false
        }
        if (this.event?.notifications.length <= 0) {
            this.addNotification()
        }
    }
}

</script>


<style scoped>

</style>
